"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VizSize {
    constructor(_sheetSize, _chromeHeight) {
        this._sheetSize = _sheetSize;
        this._chromeHeight = _chromeHeight;
    }
    get sheetSize() {
        return this._sheetSize;
    }
    get chromeHeight() {
        return this._chromeHeight;
    }
}
exports.VizSize = VizSize;
//# sourceMappingURL=VizSize.js.map